import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import styles from './epstEvaluation.module.scss';

const SpeakingQuestion = ({ questionData, onScoreChange }) => {
	const { question, points, answer, question_id } = questionData;

	const [score, setScore] = useState(0);
	const [earnedPoints, setEarnedPoints] = useState(0);

	const handleScoreChange = (e) => {
		const value = parseInt(e.target.value, 10);
		if ((value >= 0 && value <= 100) || isNaN(value)) {
			setScore(e.target.value);
		}
	};

	useEffect(() => {
		const calculated = score ? Math.round((score * points) / 100) : 0;
		setEarnedPoints(calculated);

		// Reporta cambios al componente padre
		onScoreChange(question_id, score, calculated);
	}, [score]);

	return (
		<div className={styles.container}>
			<p className={styles.questionText}><strong>{question}</strong></p>
			

			{answer ? (
				<audio controls className={styles.audioPlayer}>
					<source
						src={`${process.env.REACT_APP_CERTIFICATIONS_API}/download/epst/speaking/${answer}`}
						type="audio/webm"
					/>
					Tu navegador no soporta audio HTML5.
				</audio>
			) : (
				<p className="text-muted">No audio submitted</p>
			)}

			<Row className="mt-4 justify-content-center text-center">
				<Col xs={12} md={4}>
					<p><strong>Puntos:</strong> {points}</p>
					<p><strong>Total obtenidos:</strong> {earnedPoints}</p>
				</Col>
				<Col xs={12} md={4}>
					<label><strong>Calificación (1 - 100):</strong></label>
					<input
						type="number"
						value={score}
						onChange={handleScoreChange}
						min="1"
						max="100"
						className={`${styles.scoreInput} form-control mx-auto`}
						style={{ maxWidth: '200px', textAlign: 'center' }}
					/>
				</Col>
			</Row>
		</div>
	);
};

export default SpeakingQuestion;